import React from 'react';
import { useTranslation } from 'react-i18next';

const AIAssistantSleepSettings = () => {
  const { t } = useTranslation();

  return <div>{t('settings.aiAssistant.sleepSettings')}</div>;
};

export default AIAssistantSleepSettings;
